import { EScrollType } from '@gem-sdk/heatmap-react';

/**
 * Default scroll type
 */
export const HEATMAP_SCROLL_CONFIG = {
  SCROLL_TYPE: EScrollType.Depth,
};
